<app-alert-block type="info">{{ 'This is the only time these codes will be shown.' }}</app-alert-block>

<ul class="codes-grid">
    <li *ngFor="let code of codes; trackBy: trackByCode" class="code">{{ code }}</li>
</ul>

<!-- Utilities follow the codes they act on, before the divider that separates the
     acknowledge gate. -->
<div class="actions-row">
    <button type="button"
            class="code-action"
            e2eId="recovery-codes-copy"
            [copyToClipboard]="codesBlock"
            copySuccessTitle="Recovery codes copied"
            copySuccessMessage="Your recovery codes were copied to your clipboard.">
        <i class="ph-bold ph-copy" aria-hidden="true"></i> {{ 'Copy all' }}
    </button>

    <button type="button"
            class="code-action"
            e2eId="recovery-codes-download"
            (click)="download()">
        <i class="ph-bold ph-download-simple" aria-hidden="true"></i> {{ 'Download .txt' }}
    </button>
</div>

<!-- Acknowledge gate — same body placement as confirm-2fa-code's trust-device row. -->
<mat-divider></mat-divider>
<mat-checkbox
    class="acknowledge"
    e2eId="recovery-codes-acknowledge"
    [checked]="acknowledged"
    [disableRipple]="true"
    (change)="onAcknowledgedChange($event.checked)">
    {{ 'I have saved my recovery codes somewhere safe.' }}
</mat-checkbox>
